// extracted by mini-css-extract-plugin
export var boxItems = "_29-1";
export var boxItemsLg = "_29-2";
export var button = "_29-7";
export var buttonHoverless = "_29-9";
export var buttonLg = "_29-8";
export var filterGroupBox = "_29-0";
export var icon = "_29-3";
export var iconSecondary = "_29-6";
export var iconWrapper = "_29-4";
export var iconWrapperLg = "_29-5";
export var truncatedLabel = "_29-a";